import { AxiosResponse } from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { fetch, post } from "src/common/networks/api-helper";
import { URL_PATHS } from "src/common/networks/url-paths";
import localStorageHelpers, {
  StorageKey,
} from "src/common/storage/local-storage-helpers";
import { useHistory } from "react-router-dom";
import ToastifyAdapter from "src/libraries/components/toastify/toastify.adapter";
export const LoginAdapter = () => {
  const history = useHistory();
  const { errorFromAPI, success } = ToastifyAdapter();
  const getAccessToken = (data: Object) => {
    post(URL_PATHS.LOGIN, data, false, true)
      .then((res) => {
        console.log(res);
        if (
          res &&
          res.data.code === 1000 &&
          res.data.result.authenticated === true
        ) {
          localStorageHelpers.save(
            StorageKey.ACCESS_TOKEN,
            res.data.result.token
          );
          success("Đăng nhập thành công");
          history.push("/");
        }
      })
      .catch((e) => {
        console.log("ERROR GET ACCESS TOKEN", e);
        errorFromAPI(e.response.data.code, e.response.data.message);
      });
  };

  const handleLogin = (data: Object) => {
    const dataObj = data as { username: string; password: string };
    const body = {
      username: dataObj.username,
      password: dataObj.password,
    };
    getAccessToken(body);
  };

  return {
    handleLogin,
  };
};
